// extracted by mini-css-extract-plugin
export default {"channels_menu":"ChannelsMenu_channels_menu__qigi4","hidden":"ChannelsMenu_hidden__v1RDF"};